<script lang="ts">
  import { Pin } from '../../components/icons';
  import type { AreasWeService } from '../types';
  export let properties: AreasWeService;
  import MapSvg from './MapSvg.svg';

  $: ({ headline, items, kicker } = properties);
</script>

<section class="px-[16px] py-[20px] pb-[39px] md:py-[80px]">
  <img
    src={MapSvg}
    alt="MapSvg"
    class="no-repeat absolute left-0 right-0 top-0 z-0 w-auto md:left-[50%] md:h-full md:translate-x-[-50%]"
  />
  <div class="relative z-10 mx-auto max-w-5xl">
    <div
      class="mb-5 flex flex-row items-center justify-center gap-2 text-center text-sm font-semibold uppercase text-[--color-primary,#1a4b8a]"
    >
      <Pin />
      {@html kicker?.value}
    </div>
    <div class="flex flex-col items-center justify-center gap-8 md:gap-16">
      <h2 class="text-center text-3xl font-bold text-[--color-primary,#1a4b8a]">
        {@html headline?.value}
      </h2>
      <div class="flex flex-wrap items-center justify-center gap-4 text-center">
        {#each items as item}
          <a
            href="#form"
            class="location-pill border-[rgba(17, 17, 17, 0.07)] flex items-center justify-center gap-2 rounded-full border bg-white p-4 text-center text-sm font-semibold uppercase shadow-sm"
          >
            <span class="text-[--color-accent,#1a4b8a]"> <Pin /></span>
            {item}
          </a>
        {/each}
      </div>
    </div>
  </div>
</section>

<style>
  .location-pill {
    background: linear-gradient(
      176deg,
      #fff 2.89%,
      rgba(240, 240, 240, 0.5) 96.98%
    );
  }
</style>
